export default defineNuxtPlugin(() => {
  const projectConfig = useProjectConfig();
  const googleAnalyticsId = projectConfig.features.googleAnalytics;

  if (!googleAnalyticsId) {
    return;
  }

  useHead({
    script: [
      {
        async: true,
        src: `https://www.googletagmanager.com/gtag/js?id=${projectConfig.features.googleAnalytics}`,
      },
      {
        innerHTML() {
          return `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', '${projectConfig.features.googleAnalytics}');
`;
        },
      },
    ],
  });
});
